import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { listPaymentReceiptContra, PaymentContraDelete } from '../store/slices/journal';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { API_BASE_URL, API_PATHS } from '../utils/constants/api.constants';
import { FaFileExcel } from "react-icons/fa";
import { FaFilePdf } from 'react-icons/fa6';
import {toast } from 'react-hot-toast';
import {excelPayRecContDownload } from "../common/ExcelDownload"

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [VoucherList, setVoucherList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
    const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Type', field: 'type' },
    { header: 'Payment Name', field: 'payment_name' },
    { header: 'Payment Date', field: 'payment_date' },
    { header: 'Debit Amount', field: 'debit_amount' },
    { header: 'Credit Amount', field: 'credit_amount' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [{ name: 'Edit', className: 'btn-default' }, { name: 'Delete', className: 'btn-cancel' }, {
                className: 'btn-danger mt-1',
                icon: <FaFilePdf style={{ fontSize: '15px' }} />,
              },],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

// Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);


  
  


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/payment-receipt-contra/edit/${item.id ? item.id : null}`);
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Journal Voucher?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(PaymentContraDelete({profile_id:id, voucher_id: item.id,type:item.type }))
        .unwrap()
        .then((data) => {
          setIsLoading(false);
          hindleReturn();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    } else {
      console.log('Deletion canceled');
    }
  };

  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(listPaymentReceiptContra({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setVoucherList(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  };

  const fetchVoucherList = async () => {

    const newItem = {
      profile_id: id ,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };
    try {
      setIsLoading(true);
      const data = await dispatch(listPaymentReceiptContra(newItem)).unwrap();
      setVoucherList(data?.data);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  const resetDates = async () => {
    const storedFinancialYear = localStorage.getItem('selectedFinancialYear'); // Example: "2022-2023"
    
    let startYear, endYear;
    
    if (storedFinancialYear) {
      // Extract the start and end year from stored financial year
      [startYear, endYear] = storedFinancialYear.split('-');
    } else {
      // If not found, determine the current financial year dynamically
      const today = new Date();
      startYear = today.getMonth() + 1 >= 4 ? today.getFullYear() : today.getFullYear() - 1;
      endYear = parseInt(startYear) + 1;
    }
  
    const defaultFromDate = `${startYear}-04-01`;
    const defaultToDate = `${endYear}-03-31`;
  console.log(defaultFromDate,defaultToDate)
    // Update state
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  
   localStorage.setItem('savedFromDate', defaultFromDate);
   localStorage.setItem('savedToDate', defaultToDate);
    // Create newItem with updated financial year
    const newItem = {
      profile_id: id,
      from_date: defaultFromDate, // Use correct date
      to_date: defaultToDate, // Use correct date
    };
  
    setIsLoading(true);
    try {
      const data = await dispatch(listPaymentReceiptContra(newItem)).unwrap();
      setVoucherList(data?.data);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  

  React.useEffect(() => {
    fetchVoucherList();
  }, [financialYear]);
  

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const search = searchQuery?.toLowerCase() || '';
  // Filter data based on search query
  const filteredParties = VoucherList?.filter(
    (party) =>
      party?.payment_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.type?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.payment_date?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      String(party?.debit_amount || '')
        .toLowerCase()
        .includes(search) ||
      party?.credit_amount?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

      const handleExcelDownload = () => {
        if (!VoucherList || VoucherList.length === 0) {
            alert("No data available for download.");
            return;
        }
    
        const selectedInvoices = selectAll && VoucherList.length > 0
            ? VoucherList.map(invoice => invoice.id)
            : selectedRows;
    
        if (!selectedInvoices || selectedInvoices.length === 0) {
            alert("Please select at least one Pay/Rec/Cont.");
            return;
        }
    
        const selectedData = VoucherList.filter(invoice => selectedInvoices.includes(invoice.id));
    
        if (selectedData.length === 0) {
            alert("No matching Pay/Rec/Cont found.");
            return;
        }
    
        try {
          excelPayRecContDownload(selectedData, "PayRecCont.xlsx");
            toast.success("Downloading Excel file successfully!");
        } catch (error) {
            console.error("Error downloading Excel file:", error);
            alert("Failed to download the Excel file. Please try again.");
        }
    };

     // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};

const handlePDF = (item) => {
  const data = `${API_BASE_URL}${API_PATHS.pdfpaymentreccont}/${id}/${item?.id}`;
  navigate('/Pdf-Viewer', { state: { data } });
};
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Payment/Receipt/Contra</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">List</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={() => navigate('/payment-receipt-contra/add', { state: { type: 'Payment' } })}>
                Add Payment
              </button>
              <button className="btn ripple btn-default" onClick={() => navigate('/payment-receipt-contra/add', { state: { type: 'Receipt' } })}>
                Add Receipt
              </button>
              <button className="btn ripple btn-default" onClick={() => navigate('/payment-receipt-contra/add', { state: { type: 'Contra' } })}>
                Add Contra
              </button>
              <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                                 Export Excel <FaFileExcel/>
                                                </button>
            </div>
          </div>

          <div class="row">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">From Date</label>
                            <input class="form-control" type="date" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate}  />
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">To Date</label>
                            <input class="form-control" type="date" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                          </div>
                        </div>
                        <div class="col-md-5 form-inline">
                          <div class="form-group">
                            <button type="submit" class="btn btn-default" onClick={() => fetchVoucherList()}>
                              Submit
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" className="btn btn-default" onClick={resetDates}>
                              Reset Date
                            </button>
                          </div>
                          <div class="form-group"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filteredParties}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filteredParties.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handlePDF={handlePDF}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows} 
                selectAll={selectAll} 
                 setSelectAll={setSelectAll} 
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default PaymentReceipt;
